import { render, staticRenderFns } from "./informacion_editoriales.vue?vue&type=template&id=5e36b0a4&scoped=true"
import script from "./informacion_editoriales.vue?vue&type=script&lang=js"
export * from "./informacion_editoriales.vue?vue&type=script&lang=js"
import style0 from "./informacion_editoriales.vue?vue&type=style&index=0&id=5e36b0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36b0a4",
  null
  
)

export default component.exports